import CustomButton from 'src/components/atoms/buttons/CustomButton';
import SaveDiscardButtons from 'src/components/atoms/buttons/SaveDiscardButton';
import { CustomField } from 'src/components/molecules/formik/CustomField';
import { TableViewSelector } from 'src/components/molecules/table/TableViewDropdown';

export const generateTablePageButtons = (tableSettings, config?) => {
  const submit = config?.submit || null;
  const hideQuickSearch = config?.hideQuickSearch || false;
  const additionalEdits = config?.additionalEdits || null;

  const components = [
    ...(hideQuickSearch ? [] : [{ isInGroupedMenu: true, component: <TableViewSelector tableSettings={tableSettings} /> },

    {
      component: (
        <CustomField
          stateProps={{
            state: tableSettings.quickFilterValues,
            setState: tableSettings.setQuickFilterValues,
          }}
          options={{
            name: "QuickFilter",
            label: "Quick search",
            height: "40px",
            topMargin: "0px",
            className: "quick-search"
          }}
        />
      ),
    }]),
    ...(submit ? [{
      component: (
        <SaveDiscardButtons
          tableSettings={tableSettings}
          submit={submit}
          additionalEdits={additionalEdits}
        />
      ),
    }] : []),
    {
      isInGroupedMenu: true,
      component: (
        <CustomButton
          variant='text'
          title="Save as Excel"

          onClick={() => tableSettings?.apiRef.current.exportDataAsExcel()}
        />
      ),
    },
    {
      isInGroupedMenu: true,
      component: (
        <CustomButton
          variant='text'
          title="Save as Csv"
          onClick={() => tableSettings?.apiRef.current.exportDataAsCsv()}
        />
      ),
    },
    {
      isInGroupedMenu: true,
      component: (
        <CustomButton
          variant='text'
          title="Print"
          onClick={() => tableSettings?.apiRef.current.exportDataAsPrint()}
        />
      ),
    },
    {
      isInGroupedMenu: true,
      component: (
        <CustomButton
          variant='text'
          title={`${tableSettings?.headerFilter ? "Hide" : "Show"} Filters`}
          onClick={() => tableSettings?.setHeaderFilter(!tableSettings?.headerFilter)}
        />
      ),
    },
  ];

  return components;
};